import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
// Copywriting estratégico: Destruye objeciones comunes del mercado local
const faqs = [{
  question: '¿Necesito una computadora o pagar Canva Pro?',
  answer: 'No. Puedes editar todas las plantillas directamente desde la aplicación de Canva en tu celular, y están optimizadas para funcionar perfectamente con la cuenta gratuita. No tienes que pagar suscripciones extra.'
}, {
  question: '¿Cómo puedo pagar si solo tengo Bolívares?',
  answer: '¡Es muy fácil! En la pantalla de pago podrás seleccionar "Pago Móvil" y el sistema te dará los datos y el monto exacto a la tasa del día. También aceptamos Binance (USDT) y Tarjetas de Crédito/Débito.'
}, {
  question: '¿Es un pago mensual o una suscripción?',
  answer: 'Cero suscripciones. Es un único pago de $17 dólares (o su equivalente en Bs). Una vez que lo compras, el material es tuyo de por vida, incluyendo futuras actualizaciones.'
}, {
  question: '¿Cómo recibo el producto después de pagar?',
  answer: 'La entrega es 100% automática. Inmediatamente después de confirmar tu pago, recibirás un correo electrónico con tu "Ticket de Acceso" (un PDF) que contiene los enlaces directos a las plantillas y a todos los bonos gratuitos.'
}, {
  question: '¿Esto funciona para un negocio físico tradicional?',
  answer: 'Absolutamente. El toolkit está diseñado precisamente para negocios locales (tiendas de ropa, minimarkets, repuestos, servicios técnicos, estética). Te ayudará a dar una imagen de empresa grande, atrayendo mejores clientes.'
}, {
  question: '¿Qué pasa si no me gusta o no me sirve?',
  answer: 'Tienes 7 días de Garantía Incondicional. Entras, revisas el material, y si sientes que no es lo que esperabas o que no aplica para tu negocio, nos escribes un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-3xl mx-auto relative z-20" data-id="element-35">
      {/* Brillo de fondo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-green-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-36" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="text-center mb-12 relative z-10" data-id="element-37">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-38">
          <HelpCircle className="w-4 h-4" data-id="element-39" /> Resolvemos tus dudas
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight" data-id="element-40">
          Preguntas{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-41">
            Frecuentes
          </span>
        </h2>
      </motion.div>

      <div className="space-y-4 relative z-10" data-id="element-42">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-[#0a0a0a] border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-cyan-500/40 shadow-[0_0_20px_rgba(34,211,238,0.1)]' : 'border-white/5 hover:border-white/20'}`} data-id="element-43">
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none group" data-id="element-44">
                <span className={`font-heading font-bold text-lg pr-4 transition-colors duration-300 ${isOpen ? 'text-cyan-400' : 'text-white group-hover:text-gray-200'}`} data-id="element-45">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-cyan-500/20 text-cyan-400' : 'bg-white/5 text-gray-400 group-hover:bg-white/10'}`} data-id="element-46">
                  <ChevronDown className="w-5 h-5" data-id="element-47" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-48">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-49">
                    <div className="px-6 pb-6 pt-2 text-gray-400 text-lg leading-relaxed border-t border-white/5 mt-2" data-id="element-50">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>
    </section>;
}